export const TOOL_MARKERS_PANE = 'toolMarkersPane'
export const panes = [{ name: TOOL_MARKERS_PANE, zIndex: 1000 }]
